import { setContext } from '@apollo/client/link/context';

export const initContext = (initialContext: Record<string, unknown>) =>
  setContext((_, previousContext) => ({
    ...previousContext,
    ...initialContext,
  }));
